import React, { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ images = [], index = 0, onClose }) => {
  const [i, setI] = useState(index);
  useEffect(() => setI(index), [index]);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') setI((v) => (v + 1) % images.length);
      if (e.key === 'ArrowLeft') setI((v) => (v - 1 + images.length) % images.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [images.length, onClose]);

  if (!images.length) return null;
  const prev = (e) => { e.stopPropagation(); setI((v) => (v - 1 + images.length) % images.length); };
  const next = (e) => { e.stopPropagation(); setI((v) => (v + 1) % images.length); };

  return (
    <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4" data-testid="lightbox" onClick={onClose}>
      <button onClick={onClose} data-testid="lightbox-close" className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"><X className="w-7 h-7" /></button>
      {images.length > 1 && (
        <button onClick={prev} data-testid="lightbox-prev" className="absolute left-3 md:left-6 text-white/70 hover:text-white transition-colors"><ChevronLeft className="w-10 h-10" /></button>
      )}
      <img src={images[i]} alt="" onClick={(e) => e.stopPropagation()} className="max-h-[85vh] max-w-[92vw] rounded-lg object-contain shadow-2xl" />
      {images.length > 1 && (
        <button onClick={next} data-testid="lightbox-next" className="absolute right-3 md:right-6 text-white/70 hover:text-white transition-colors"><ChevronRight className="w-10 h-10" /></button>
      )}
      {images.length > 1 && (
        <div className="absolute bottom-5 text-white/70 text-sm tracking-widest">{i + 1} / {images.length}</div>
      )}
    </div>
  );
};

export default Lightbox;
